// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__1qnxE","inner":"styles_inner__17uzI","error404":"styles_error404__N3ZPG","title":"styles_title__1rBx_"};